


























import { Component, Vue } from 'vue-property-decorator';
import { supportedLanguages } from '@/util/i18n';

@Component
export default class ChangeLanguageIcon extends Vue {
  private displayedLanguageChanger: Boolean = false;
  private toggleLanguageChanger(): void {
    this.displayedLanguageChanger = !this.displayedLanguageChanger;
  }
  private get locale(): string {
    return this.$store.getters['i18n/locale'];
  }
  private set locale(language: string) {
    this.$store.dispatch('i18n/setLocaleWithi18n', { locale: language });
  }
  private get languages(): string[] {
    return this.$i18n.availableLocales;
  }
  private languageFullName(language: string): string {
    return supportedLanguages[language];
  }
  private chooseLocale(language: string): void {
    this.locale = language;
    this.toggleLanguageChanger();
  }
}
